  const generateSrcset = (image, widths = []) => {
    const imageUrl = new URL(image["src"]);
    return widths.filter((width) => width <= image["width"]).map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    }).join(", ");
  }

  const createImageElement = (image, classes, sizes, productTitle) => {
    const previewImage = image["preview_image"];
    const newImage = new Image(previewImage["width"], previewImage["height"]);
    newImage.className = classes;
    newImage.alt = image["alt"] || productTitle;
    newImage.sizes = sizes;
    newImage.src = previewImage["src"];
    newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
    newImage.loading="lazy"
    return newImage;
  }

  const checkSwatches = () => {
    document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
      wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
        input.addEventListener('click', (event) => {
          const primaryImage = wrapper.querySelector(".media--first");
          const secondaryImage = wrapper.querySelector(".media--second");
          const handleProduct = wrapper.dataset.product;
          
          if (event.currentTarget.checked && primaryImage) {
            wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
            if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
              if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
                wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
                wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
              }
              wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
            }
            
            const currentColor = event.currentTarget.value;

            jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
              const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];
              if (variant) {
                const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
                
                if (newPrimaryImage.src !== primaryImage.src) {
                  let flag = false;
                  if (secondaryImage) {
                    const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                    const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                    if (secondaryImagePathname == newPrimaryImagePathname) {
                      primaryImage.remove();
                      secondaryImage.classList.remove('media--second');
                      secondaryImage.classList.add('media--first');
                      flag = true;
                    } 
                  }
                  if (flag == false) {
                    primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                    setTimeout(function(){
                      primaryImage.replaceWith(newPrimaryImage);
                      newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                      if (secondaryImage) {
                        secondaryImage.remove();                                    
                      }
                    }, 200);
                  }
                }
              }
            });
          }
        })
      })
    })
  }

  function colorSwatches() {
    checkSwatches();

    document.addEventListener('shopify:section:load', function () {
      checkSwatches();
    });
  }

(function () {
  colorSwatches();
})()

$('.sbwye .product__media').filter(function(){
  if(!$(this).hasClass('product__deferred_media')){
  var edoieofo1 = $(this).find('img').first().attr('src');
  var cjdA = $('<a></a>');
  cjdA.attr('href',edoieofo1).attr('data-fancybox','group');
  cjdA.append($(this).find('img').first());
  $(this).append(cjdA);
  }
});

$('.tjoshnbow .multicolumn-list__item').filter(function(){
	var oAA = $(this).find('.kjfoed-link'),
	oSrc = $(this).find('.multicolumn-card__image-item img').attr('src');
	oAA.attr('href',oSrc);
});

var jkfuFirst = $('.product .product-about').first();
jkfuFirst.find('.product-about__accordion-title').addClass('active');
jkfuFirst.find('.product-about__accordion-content').show();

$('.collection-grid-card').filter(function(){
  var gfgst = $(this).find('.card--product .media img').last();
  $(this).find('.swatch-wrapper .swatch').first().addClass('active');
  gfgst.attr('fswe',gfgst.attr('src'));
});

$('.swatch-wrapper .swatch').click(function(){

  // 当前 swatch 在父容器中的位置（从 0 开始）
  var idid = $(this).index() + 1;

  // 方法：从 data-variant-images 取第 i 个图
  function getVariantImage(i, element) {
    var raw = $(element).attr('data-variant-images');
    if (!raw) return null;

    var jsonString = raw.replace(/&quot;/g, '"').trim();
    var mapping = {};
    try {
      mapping = JSON.parse(jsonString);
    } catch (e) {
      console.error("JSON parse error:", e);
      return null;
    }

    var keys = Object.keys(mapping);
    if (i <= 0 || i > keys.length) return null;

    var key = keys[i - 1]; // 把 1 转成 0 索引
    var url = mapping[key] || '';
    // 补全协议
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url;
  }

  // 当前商品卡片
  var card = $(this).closest('.collection-grid-card');

  // 取对应颜色图
  var imgUrl = getVariantImage(idid, card.find('.product-card__images')),
      imgUrl2 = getVariantImage(3, card.find('.product-card__images')),
      imgUrl3 = card.find('.card--product a.media img').last().attr('fswe');
  

  if (!imgUrl) return;

  // ✅ 找到正确的主图元素
  // 取卡片内 .media a 里的第一个 img
  var $mainImg = card.find('.card--product a.media img').first(),
      $mainImg2 = card.find('.card--product a.media img').last();

  // 如果没有找到，再试更宽泛的
  if ($mainImg.length === 0) {
    $mainImg = card.find('img').first();
  }

  // 最终替换
  $mainImg
  .attr('src', imgUrl)
  .attr('srcset', imgUrl + " 1x")
  .attr('loading', "eager");

  if(idid==2){

  $mainImg2
  .attr('src', imgUrl2)
  .attr('srcset', imgUrl2 + " 1x")
  .attr('loading', "eager");

  }else{

    $mainImg2
  .attr('src', imgUrl3)
  .attr('srcset', imgUrl3 + " 1x")
  .attr('loading', "eager");

  }


  // 可选：让其它 swatch 取消 active 样式
  
  card.find('.swatch').removeClass('active');
  $(this).addClass('active');

});

